var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPt = function SvgPt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21799_21074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "rotate(-90 10 10)",
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21799_21074)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "rotate(-90 10 10)",
    fill: "#E72B1B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20,
    fill: "#2D6D19"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 8.51946 5.6435 7.18922 6.66606 6.2737L6.66794 6.25185L6.68861 6.25363C7.57054 5.47351 8.72997 5 10 5C11.5793 5 12.9876 5.73219 13.9039 6.87563L13.9179 6.87685L13.9167 6.89167C14.5949 7.74509 15 8.82523 15 10ZM9.75 10.9383L5.62527 9.95072C5.62585 9.89851 5.62734 9.84653 5.62973 9.79478L7.84423 9.32692L9.75 10.1932V10.9383ZM9.75 9.64395L8.66913 9.15265L9.75 8.9243V9.64395ZM10.25 8.91071V9.87122L11.9539 10.6457L14.3739 10.1004C14.3746 10.067 14.375 10.0336 14.375 10C14.375 9.93082 14.3734 9.86201 14.3702 9.79362L10.25 8.91071ZM10.25 11.0297V10.4205L11.1461 10.8278L10.25 11.0297ZM11.2918 11.3075L11.9 11.1704L13.2141 11.7678L11.2918 11.3075ZM14.331 10.6226L12.7078 10.9884L14.0702 11.6077C14.1936 11.2953 14.2822 10.9653 14.331 10.6226ZM13.9147 8.04443C14.1051 8.42478 14.2416 8.83673 14.3144 9.27031L11.2353 8.6105L13.9147 8.04443ZM8.83281 8.60703L7.90159 8.80377L7.72766 8.7247L8.81707 8.60366L8.83281 8.60703ZM7.07669 8.97804L5.68529 9.272C5.73307 8.98673 5.80846 8.71081 5.90861 8.4471L6.34973 8.64761L6.375 8.875L6.7567 8.83259L7.07669 8.97804ZM7.27103 8.27236L6.2522 8.05404L6.83829 8.32045L7.27103 8.27236ZM13.6652 12.3899L10.25 11.5722V12.4018L13.5124 12.6089C13.5654 12.5375 13.6164 12.4645 13.6652 12.3899ZM13.1032 13.0839L10.25 12.9028V14.368C11.3634 14.3053 12.3656 13.8262 13.1032 13.0839ZM9.75 12.37V11.6549L7.27429 12.2128L9.75 12.37ZM6.53137 12.6667L9.75 12.871V14.368C8.43983 14.2942 7.28375 13.6439 6.53137 12.6667ZM5.65003 10.4708L9.08287 11.2927L6.09103 11.9669C5.85993 11.5086 5.70708 11.004 5.65003 10.4708ZM8.8425 8.09776L6.36365 7.56657C6.55554 7.28038 6.78033 7.0181 7.0326 6.78514L9.75 7.0194V7.99692L8.8425 8.09776ZM10.25 7.94137L13.6354 7.56521C13.584 7.48853 13.5302 7.41357 13.4741 7.34044L10.25 7.0625V7.94137ZM10.25 6.56065L12.979 6.79591C12.2549 6.12235 11.3021 5.6913 10.25 5.63202V6.56065ZM7.61249 6.33327L9.75 6.51754V5.63202C8.96409 5.6763 8.23363 5.92801 7.61249 6.33327Z",
    fill: "#FEEA3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 11V6.625H12.8748V10.9796C12.6554 11.7564 11.7618 13.2979 9.94266 13.2489C8.12351 13.1998 7.26463 11.736 7.125 11Z",
    fill: "#E72B1B",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 10.7113V7.75H11.751L11.751 10.7113C11.6096 11.1951 11.0337 12.1548 9.86139 12.1243C8.68905 12.0937 8.29311 11.1696 8.20312 10.7113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 9.125V7.875H10.375V9.125H11.5625V9.9375H10.375V11.25H9.625V9.9375H8.375V9.125H9.625Z",
    fill: "#5A74AC"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pt.84253d450940bfc8512aba27501f3dbc.svg";